<template>
    <main-content>
        <div
            class="card-body mt-5 bg-white shadow-sm"
            style="border-radius: 10px"
        >
            <div class="d-flex">
                <div class="px-4 ml-auto">{{ ticket.subject }}</div>
                <div class="px-4">
                    <router-link class="text-success" to="/tickets"
                        >بازگشت</router-link
                    >
                </div>
            </div>
            <hr />

            <div class="ticket-thread mt-4">
                <div
                    v-for="(comment, index) in ticket.comments"
                    :key="index"
                    :class="['ticket-msg', comment.is_user ? 'ticket-msg--user' : 'ticket-msg--support']"
                >
                    <div class="ticket-msg__bubble">
                        <div class="ticket-msg__author">
                            <i v-if="!comment.is_user" class="fas fa-headset ml-1"></i>
                            {{ comment.is_user ? comment.user_name : 'پشتیبانی پی استار' }}
                        </div>
                        <div class="ticket-msg__text" v-html="comment.content"></div>
                        <a
                            class="ticket-msg__file"
                            :href="comment.file"
                            v-if="comment.file"
                            ><i class="fas fa-paperclip ml-1"></i>فایل پیوست</a
                        >
                        <div
                            class="ticket-msg__signature"
                            v-if="comment.signature && !comment.is_user"
                            v-html="comment.signature"
                        ></div>
                        <div class="ticket-msg__date">{{ comment.date }}</div>
                    </div>
                </div>
            </div>

            <form
                @submit.prevent="send_comment"
                id="comment-form"
                class="p-4 py-5"
            >
                <div class="form-group">
                    <label>متن پاسخ </label>
                    <textarea
                        rows="5"
                        id="content"
                        name="content"
                        class="form-control"
                        v-model="newComment"
                    ></textarea>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label
                            for="file"
                            class="d-block btn btn-secondary btn-wide label-file"
                        >
                            {{ $t('label.select_file') }}
                        </label>
                        <input
                            @change="processFile"
                            type="file"
                            class="custom-file-upload"
                            name="file"
                            id="file"
                            accept="image/png,.jpg,.jpeg,.zip"
                        />
                    </div>
                    <div
                        class="custom-alert position-relative z-index-low mb-3"
                    >
                        <div class="my-2 text-secondery" role="alert">
                            <div>
                                فرمت های مجاز فایل ضمیمه شامل فرمتهای مجاز فایل
                                <b>zip, jpeg, png, jpg</b>می‌باشد.
                            </div>
                        </div>
                    </div>
                </div>
                <button id="submit_button" class="btn btn-success float-left">
                    ارسال پاسخ
                </button>
            </form>
        </div>
        <div
            class="modal fade"
            data-backdrop="static"
            data-keyboard="false"
            id="approve_modal"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="d-flex w-100 pl-4">
                            <div class="col-11 modal-title h5">
                                نظر سنجی تیکت
                            </div>
                            <div class="col-1 px-4">
                                <button
                                    type="button"
                                    @click="hideModal"
                                    class="btn btn-sm btn-circle btn-icon bg-white"
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                            <hr class="my-3" />
                        </div>
                        <div class="row pr-4 pb-4 w-100">
                            <div
                                class="row text-dark bg-white mr-1 mt-3 justify-content-center text-white-in-dark-mode w-100"
                                style="
                                    font-size: 60px;
                                    border-radius: 20px;
                                    box-shadow: rgb(140, 227, 214) 0px 0px 5px;
                                "
                            >
                                <div class="" style="">
                                    <i
                                        v-for="(item, index) in 5"
                                        :key="index"
                                        @click="selectStar(item)"
                                        aria-hidden="true"
                                        class="la la-star px-1"
                                        :style="
                                            starSelected > index
                                                ? 'color: yellow'
                                                : ''
                                        "
                                    ></i>
                                </div>
                            </div>

                            <div class="row mr-1 mt-5 w-100">
                                <textarea
                                    style="height: 120px"
                                    class="form-control"
                                    placeholder="توضیحات خود را وارد کنید"
                                    v-model="feedback"
                                    :style="
                                        errors.feedback
                                            ? 'border-color: #cd2222 !important;'
                                            : 'border-color: #333 !important'
                                    "
                                ></textarea>
                                <ul v-if="errors.feedback">
                                    <li
                                        class="text-danger"
                                        v-for="(item, index) in errors.feedback"
                                        :key="index"
                                    >
                                        <small class="text-danger">
                                            {{ item }}
                                        </small>
                                    </li>
                                </ul>
                            </div>

                            <div class="row mt-2 justify-content-start w-100">
                                <ul>
                                    <li class="text-danger">
                                        <small class="text-danger"
                                            >فقط یکبار در این نظر سنجی می توانید
                                            شرکت کنید و قابل ویرایش نیست
                                        </small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="d-flex px-1 justify-content-end mb-3">
                            <button
                                @click="hideModal()"
                                class="btn btn-danger btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                style="font-size: 14px"
                            >
                                انصراف
                            </button>

                            <button
                                v-if="!this.loading"
                                @click="submitPoll()"
                                class="btn btn-success btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                style="font-size: 14px"
                            >
                                ثبت
                            </button>

                            <button
                                v-else
                                class="btn btn-success btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                style="font-size: 14px"
                            >
                                <span class="spinner-border"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
import MainContent from '@/components/main-content';
import { mapActions, mapGetters } from 'vuex';
import toastr from 'toastr';
import $ from 'jquery';
import { ticketService } from '@/common/api.service';
import { i18n } from '@/plugins/i18n';
import { KTApp } from '@/plugins/core/app';

export default {
    name: 'detail',
    data() {
        return {
            newComment: null,
            starSelected: 1,
            feedback: null,
            loading: false,
            errors: []
        };
    },
    components: { MainContent },
    computed: {
        ...mapGetters('ticket', ['ticket']),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: 'toast-bottom-center',
                preventDuplicates: false,
                rtl: false
            };
            return toastr;
        }
    },
    methods: {
        submitPoll() {
            this.errors = [];
            this.loading = true;
            let params = {
                ticket_id: this.ticket.id,
                feedback: this.feedback,
                point: this.starSelected
            };

            ticketService
                .pollTicket(params)
                .then((response) => {
                    this.toastr.success(response.data.message);
                    this.hideModal();
                })
                .catch(({ response }) => {
                    this.errors = response.data.errors;
                    this.toastr.error(response.data.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        selectStar(value) {
            this.starSelected = value;
        },
        hideModal() {
            $('#approve_modal').modal('hide');
        },
        openModal() {
            $('#approve_modal').modal('show');
        },
        send_comment() {
            let form = $('#comment-form');
            let btn = $('#submit_button');

            form.validate({
                ignore: '.ignore',
                rules: {
                    content: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn);

            var data = {
                ticket_id: this.$route.params.hashid,
                content: this.newComment
            };

            if (this.file) {
                data.file = this.file;
            }

            this.$store
                .dispatch('ticket/submitComment', data)
                .then((response) => {
                    this.newComment = '';
                    this.file = '';
                    $('#file').val('');
                })
                .catch(({ response }) => {
                    if (response.status >= 400 && response.status < 500) {
                        form.validate().showErrors(response.data.data);
                    } else {
                        this.toastr.error('خطای سرور!');
                    }
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                });
        },
        processFile(e) {
            this.file = event.target.files[0];
            let size_validation = this.validateSize(event.target);
            if (size_validation) this.validateFormat(event.target);
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('label.comment_files_allowed_size'));
                $('#file').val('');
                this.file = '';
                $(file).val('');
                return false;
            } else {
                return true;
            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'zip':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $('#file').val('');
                    this.file = '';
                    $(file).val('');
            }
        }
    },
    async mounted() {
        await this.$store.dispatch('ticket/find', this.$route.params.hashid);

        if (this.ticket.could_poll_ticket) {
            this.openModal();
        }
    }
};
</script>

<style scoped>
.ticket-thread {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 0 4px;
}
.ticket-msg {
    display: flex;
}
.ticket-msg--user {
    justify-content: flex-start;
}
.ticket-msg--support {
    justify-content: flex-end;
}
.ticket-msg__bubble {
    max-width: 85%;
    padding: 10px 14px;
    border-radius: 14px;
    word-break: break-word;
}
.ticket-msg--user .ticket-msg__bubble {
    background: rgba(0, 193, 164, 0.15);
    border-top-right-radius: 4px;
}
.ticket-msg--support .ticket-msg__bubble {
    background: rgba(125, 125, 125, 0.18);
    border-top-left-radius: 4px;
}
.ticket-msg__author {
    font-size: 0.8rem;
    font-weight: bold;
    opacity: 0.8;
    margin-bottom: 4px;
}
.ticket-msg__text {
    white-space: pre-line;
}
.ticket-msg__file {
    display: inline-block;
    margin-top: 6px;
}
.ticket-msg__date {
    font-size: 0.72rem;
    opacity: 0.6;
    margin-top: 6px;
    text-align: left;
}
@media (min-width: 768px) {
    .ticket-msg__bubble {
        max-width: 65%;
    }
}
.la-star {
    cursor: pointer;
}
.la-star:hover {
    color: yellow;
}
</style>